import cn from 'classnames';
import { type ImageProps, Stub } from '@direct-frontend/components';
import type { ImageInfo } from '../../api/image';
import { makeModifierClassname } from '../../lib/makeModifierClassname';
import { ResponsiveImage } from '../ResponsiveImage';
import styles from './CompanyLogo.module.css';

export const CompanyLogoStub: React.FC<Omit<CompanyLogoProps, 'logo' | 'minWidth' | 'position'>> = ({ className }) => (
    <Stub width="140px" height="40px" className={className} />
);

type CompanyLogoPosition = 'header' | 'footer' | 'product';

export type CompanyLogoProps = Omit<ImageProps, 'src' | 'height' | 'width' | 'position'> & {
    position: CompanyLogoPosition;
    logo?: ImageInfo;
};

const modifier = makeModifierClassname(styles, 'logo');

export const CompanyLogo: React.FC<CompanyLogoProps> = ({ logo, className, position = 'header', ...imageProps }) => {
    if (!logo) {
        return (
            <CompanyLogoStub
                {...imageProps}
                className={cn(className, modifier.className, modifier('position', position))}
            />
        );
    }

    return (
        <ResponsiveImage
            {...imageProps}
            priority
            fit="contain"
            className={cn(className, modifier.className, modifier('position', position))}
            sizes="180px"
            alt="Лого"
            src={logo}
        />
    );
};
